var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('v-icon',{staticClass:"mr-1",attrs:{"x-small":"","color":_vm.color}},[_vm._v("circle")]),_c('router-link',{attrs:{"to":{
            name: _vm.routeType.RESTAURANT_EDIT,
            params: { id: _vm.id },
        }}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }